export enum OrdersActions {
  SET_FEATURE_FLAG = 'SET_FEATURE_FLAG',
}

export enum OrdersFeatureFlags {
  IS_HEXA_V2_ENABLED = 'isHexaV2Enabled',
  TURBO_COLOR = 'turboColor',
  IS_EDIT_ORDER_ENABLED = 'isEditOrderEnabled',
  EDIT_ORDER_INFO_VIDEO = 'editOrderInfoVideo',
  IS_PICKUP_CODE_ENABLED = 'isPickupCodeEnabled',
  IS_STOCKOUT_NEW_FLOW_ENABLED = 'isStockoutNewFlowEnabled',
}
